import React from 'react';
import './SideBar.css';

const SideBar = ({ onSelect, onLogout }) => {
  return (
    <div className="sidebar">
      <h2 className="sidebar-title">Admin</h2>
      <ul className="sidebar-menu">
        <li onClick={() => onSelect('cadastrar')}>Cadastrar Imóvel</li>
        <li onClick={() => onSelect('consultar')}>Consultar Imóvel</li>
        <li onClick={() => onSelect('admins')}>Cadastrar Admin</li>
        <li onClick={() => onSelect('senha')}>Alterar Senha</li>
      </ul>
      {onLogout && (
        <button className="sidebar-logout" onClick={onLogout}>
          Sair
        </button>
      )}
    </div>
  );
};

export default SideBar;
